(function() {
  // ============ ADMIN EXCLUSION (πριν από οτιδήποτε) ============
  // Αν είναι admin (Kostas), τίποτα δεν γράφεται στο Firestore.
  var IS_ADMIN = (function() {
    try {
      // Manual flag (set από κουμπί στο dashboard)
      if (localStorage.getItem('gts_admin') === 'true') return true;
      // URL parameter για quick activation: ?gts_admin=1
      if (location.search.indexOf('gts_admin=1') !== -1) {
        localStorage.setItem('gts_admin', 'true');
        return true;
      }
      // Auto-detect: Shopify admin pages
      var host = location.hostname.toLowerCase();
      if (host.indexOf('myshopify.com') !== -1) return true;
      if (location.pathname.indexOf('/admin') === 0) return true;
      // Localhost
      if (host === 'localhost' || host === '127.0.0.1') return true;
      return false;
    } catch(e) { return false; }
  })();

  // ============ BOT DETECTION ============
  var IS_BOT = (function() {
    try {
      var ua = (navigator.userAgent || '').toLowerCase();
      var botPatterns = [
        'bot', 'crawler', 'spider', 'crawling',
        'googlebot', 'bingbot', 'yandex', 'baiduspider', 'duckduckbot',
        'claudebot', 'gptbot', 'chatgpt', 'oai-searchbot', 'perplexitybot',
        'anthropic', 'claude-web', 'ccbot', 'cohere',
        'facebookexternalhit', 'twitterbot', 'linkedinbot', 'slackbot',
        'whatsapp', 'telegrambot', 'discordbot',
        'applebot', 'amazonbot', 'pinterest', 'redditbot',
        'ahrefsbot', 'semrushbot', 'mj12bot', 'dotbot',
        'screaming frog', 'sitebulb', 'lighthouse', 'pagespeed',
        'headlesschrome', 'phantomjs', 'puppeteer', 'playwright',
        'curl', 'wget', 'python-requests', 'go-http-client'
      ];
      for (var i = 0; i < botPatterns.length; i++) {
        if (ua.indexOf(botPatterns[i]) !== -1) return true;
      }
      if (navigator.webdriver === true) return true;
      return false;
    } catch(e) { return false; }
  })();

  // Συνδυασμός: αν είναι bot ή admin, σταματάμε όλο το tracking
  var SKIP_TRACKING = IS_BOT || IS_ADMIN;

  var FIREBASE_CONFIG = {
    apiKey: "AIzaSyBHR7c9HCOXizWGutDmCGJxcAaEKJTnO5I",
    authDomain: "green-tshirts-chat.firebaseapp.com",
    projectId: "green-tshirts-chat",
    storageBucket: "green-tshirts-chat.firebasestorage.app",
    messagingSenderId: "73888519696",
    appId: "1:73888519696:web:53d261417309dd1b33dc95"
  };

  var AVATAR = 'https://cdn.shopify.com/s/files/1/0994/4088/6089/files/leaf_avatar.webp?v=1775670216';
  var GURL = 'https://gts-api.greentshirts-gr.workers.dev';

  // ============ IP-BASED ADMIN AUTO-DETECT ============
  // Ο browser δεν ξέρει τη δημόσια IP του, οπότε ρωτάμε το Worker (που τη βλέπει
  // μέσω CF-Connecting-IP). Αν η IP είναι του Kostas, σημειώνουμε gts_admin στο
  // localStorage. Από εκεί και πέρα το υπάρχον IS_ADMIN κόβει όλο το tracking,
  // συγχρονισμένα και χωρίς καμία επιπλέον κλήση.
  // Σημ.: ελέγχουμε max 1/ημέρα ανά browser ώστε να μην επιβαρύνουμε τους πελάτες.
  (function() {
    try {
      if (localStorage.getItem('gts_admin') === 'true') return; // ήδη γνωστός admin
      var lastCheck = parseInt(localStorage.getItem('gts_ipcheck_ts') || '0', 10);
      if (Date.now() - lastCheck < 86400000) return;             // 1 έλεγχος/ημέρα
      localStorage.setItem('gts_ipcheck_ts', String(Date.now()));
      var xip = new XMLHttpRequest();
      xip.open('GET', GURL + '?checkip=1', true);
      xip.timeout = 4000;
      xip.onreadystatechange = function() {
        if (xip.readyState !== 4) return;
        try {
          var r = JSON.parse(xip.responseText);
          if (r && r.admin === true) localStorage.setItem('gts_admin', 'true');
        } catch(e) {}
      };
      xip.send();
    } catch(e) {}
  })();

  var db = null;
  var fbReady = false;
  var fbQueue = [];

  function withFirebase(fn) {
    if (SKIP_TRACKING) return; // bots ή admin: όχι writes
    if (fbReady && db) { fn(); return; }
    fbQueue.push(fn);
  }

  function flushFirebase() {
    fbReady = true;
    fbQueue.forEach(function(fn) { try { fn(); } catch(e) {} });
    fbQueue = [];
  }

  function loadFirebase(cb) {
    if (SKIP_TRACKING) { cb(); return; }
    if (fbReady) { cb(); return; }
    var s1 = document.createElement('script');
    s1.src = 'https://www.gstatic.com/firebasejs/9.23.0/firebase-app-compat.js';
    s1.onload = function() {
      var s2 = document.createElement('script');
      s2.src = 'https://www.gstatic.com/firebasejs/9.23.0/firebase-firestore-compat.js';
      s2.onload = function() {
        try {
          if (!firebase.apps.length) firebase.initializeApp(FIREBASE_CONFIG);
          db = firebase.firestore();
          flushFirebase();
          cb();
        } catch(e) { console.log('Firebase init error', e); cb(); }
      };
      document.head.appendChild(s2);
    };
    document.head.appendChild(s1);
  }

  // ============ TRAFFIC SOURCE DETECTION ============
  function detectTrafficSource() {
    try {
      var ref = document.referrer || '';
      var url = new URL(window.location.href);
      var params = url.searchParams;

      var utmSource = params.get('utm_source') || '';
      var utmMedium = params.get('utm_medium') || '';
      var utmCampaign = params.get('utm_campaign') || '';

      var source = 'direct';
      var sourceCategory = 'direct';

      if (utmSource) {
        source = utmSource;
        sourceCategory = utmMedium || 'campaign';
      } else if (ref) {
        try {
          var refUrl = new URL(ref);
          var refHost = refUrl.hostname.toLowerCase().replace(/^www\./, '');

          if (refHost === 'green-tshirts.com' || refHost.endsWith('.green-tshirts.com')) {
            return null;
          }

          source = refHost;

          if (/google\.|bing\.|yahoo\.|duckduckgo\.|yandex\./.test(refHost)) {
            sourceCategory = 'search';
          } else if (/instagram\.|facebook\.|tiktok\.|twitter\.|x\.com|linkedin\.|pinterest\.|reddit\.|youtube\./.test(refHost)) {
            sourceCategory = 'social';
          } else if (/chatgpt\.|chat\.openai\.|claude\.|perplexity\.|gemini\.google\.|bard\.google\.|copilot\./.test(refHost)) {
            sourceCategory = 'ai';
          } else if (/mail\.|gmail\.|outlook\.|yahoo\.com\/mail/.test(refHost)) {
            sourceCategory = 'email';
          } else {
            sourceCategory = 'referral';
          }
        } catch(e) {
          source = 'unknown';
          sourceCategory = 'unknown';
        }
      }

      return {
        trafficSource: source,
        sourceCategory: sourceCategory,
        referrerFull: ref || '',
        utmSource: utmSource,
        utmMedium: utmMedium,
        utmCampaign: utmCampaign,
        landingPage: window.location.href,
        firstSeenAt: Date.now()
      };
    } catch(e) {
      return null;
    }
  }

  function init() {
    var cfg = document.getElementById('gts-cfg');
    if (!cfg) return;

    var IS_B2B = cfg.getAttribute('data-b2b') === 'true';
    var PT = cfg.getAttribute('data-pt') || '';
    var PP = cfg.getAttribute('data-pp') || '';
    var PA = cfg.getAttribute('data-pa') || '';
    var PD = cfg.getAttribute('data-pd') || '';
    var CT = cfg.getAttribute('data-ct') || '';
    var CC = cfg.getAttribute('data-cc') || '';

    var retailersRaw = (document.getElementById('gts-retailers') || {}).textContent || '';
    var retailersList = retailersRaw.trim()
      ? retailersRaw.trim().split(';').filter(function(r) { return r.trim(); }).map(function(r) {
          var parts = r.trim().split('|');
          return (parts[0]||'').trim() + ' | ' + (parts[4]||'').trim() + ' | ' + (parts[1]||'').trim() + ' | ' + (parts[2]||'').trim() + ' | ' + (parts[3]||'').trim();
        }).join('\n')
      : '';

    var hist = [], sys = null, loading = false, ready = false, greeted = false, isOpen = false, userEmail = '', userName = '';
    var sessionId = null;
    // TEST: αν έχει ήδη εμφανιστεί/απαντηθεί το προαιρετικό email prompt (μετά τη 2η ερώτηση)
    var emailAsked = false;
    var chatOpenedLogged = false;
    var humanMode = false;
    var typingTimer = null;
    var lang = 'en';
    var langDetected = false;
    var lastCartSnapshot = null;
    var currentCart = null; // για cart context awareness
    // Σωρευτικά tokens της συνομιλίας — για «κόστος ανά συνομιλία» στο dashboard.
    var tokIn = 0, tokOut = 0, tokCW = 0, tokCR = 0;

    var greetings = {
      'el': 'Γεια! Καλωσήλθες στο Green T-Shirts. Πως μπορω να βοηθησω;',
      'en': 'Hi! Welcome to Green T-Shirts. How can I help you?',
      'de': 'Hallo! Willkommen bei Green T-Shirts. Wie kann ich helfen?',
      'fr': 'Bonjour! Bienvenue chez Green T-Shirts. Comment puis-je vous aider?',
      'it': 'Ciao! Benvenuto su Green T-Shirts. Come posso aiutarti?',
      'es': 'Hola! Bienvenido a Green T-Shirts. Como puedo ayudarte?',
      'nl': 'Hallo! Welkom bij Green T-Shirts. Hoe kan ik helpen?',
      'pl': 'Czesc! Witamy w Green T-Shirts. Jak moge pomoc?',
      'pt': 'Ola! Bem-vindo a Green T-Shirts. Como posso ajudar?'
    };

    // TEST: κείμενα για το προαιρετικό, μη-υποχρεωτικό email prompt μετά τη 2η ερώτηση.
    var emailAskMsgs = {
      'el': 'Θες να αφήσεις το email σου; Έτσι μπορούμε να σε ενημερώσουμε για την παραγγελία σου ή για προσφορές. Προαιρετικό!',
      'en': 'Want to leave your email? We can use it to follow up on your order or send you offers. Totally optional!',
      'de': 'Möchtest du deine E-Mail hinterlassen? So können wir dich zu deiner Bestellung oder Angeboten informieren. Optional!',
      'fr': 'Souhaitez-vous laisser votre email? Cela nous permet de vous tenir informé de votre commande ou de nos offres. Facultatif!',
      'it': 'Vuoi lasciare la tua email? Cosi possiamo aggiornarti sul tuo ordine o sulle offerte. Facoltativo!',
      'es': 'Quieres dejarnos tu email? Asi podemos avisarte sobre tu pedido u ofertas. Opcional!',
      'nl': 'Wil je je e-mail achterlaten? Zo kunnen we je op de hoogte houden van je bestelling of aanbiedingen. Optioneel!',
      'pl': 'Chcesz zostawic swoj email? Damy Ci znac o zamowieniu lub ofertach. Opcjonalnie!',
      'pt': 'Queres deixar o teu email? Assim podemos avisar-te sobre a encomenda ou ofertas. Opcional!'
    };
    var emailAskBtns = {
      'el': { send: 'Αποστολή', skip: 'Όχι τώρα', thanks: 'Ευχαριστούμε!', ok: 'Εντάξει!' },
      'en': { send: 'Send', skip: 'Not now', thanks: 'Thank you!', ok: 'No problem!' },
      'de': { send: 'Senden', skip: 'Nicht jetzt', thanks: 'Danke!', ok: 'Kein Problem!' },
      'fr': { send: 'Envoyer', skip: 'Pas maintenant', thanks: 'Merci!', ok: 'Pas de souci!' },
      'it': { send: 'Invia', skip: 'Non ora', thanks: 'Grazie!', ok: 'Nessun problema!' },
      'es': { send: 'Enviar', skip: 'Ahora no', thanks: 'Gracias!', ok: 'No hay problema!' },
      'nl': { send: 'Versturen', skip: 'Niet nu', thanks: 'Bedankt!', ok: 'Geen probleem!' },
      'pl': { send: 'Wyslij', skip: 'Nie teraz', thanks: 'Dziekujemy!', ok: 'Bez problemu!' },
      'pt': { send: 'Enviar', skip: 'Agora nao', thanks: 'Obrigado!', ok: 'Sem problema!' }
    };

    function genId() {
      return Date.now().toString(36) + Math.random().toString(36).substr(2, 6);
    }

    try {
      var saved = sessionStorage.getItem('gts_chat');
      if (saved) {
        var parsed = JSON.parse(saved);
        hist = parsed.hist || [];
        userEmail = parsed.email || '';
        userName = parsed.name || '';
        greeted = parsed.greeted || false;
        sessionId = parsed.sessionId || null;
        lang = parsed.lang || 'en';
        langDetected = parsed.langDetected || false;
        tokIn = parsed.tokIn || 0;
        tokOut = parsed.tokOut || 0;
        tokCW = parsed.tokCW || 0;
        tokCR = parsed.tokCR || 0;
        emailAsked = parsed.emailAsked || false;
      }
    } catch(e) {}

    if (!sessionId) sessionId = genId();

    try {
      if (!hist || hist.length === 0) {
        var savedVisitor = localStorage.getItem('gts_visitor_id');
        if (savedVisitor) {
          sessionId = savedVisitor;
        } else {
          localStorage.setItem('gts_visitor_id', sessionId);
        }
      } else {
        localStorage.setItem('gts_visitor_id', sessionId);
      }
    } catch(e) {}

    // Visitor tracking — με traffic source την πρώτη φορά
    var trafficData = detectTrafficSource();
    var visitorData = {
      sessionId: sessionId,
      lastSeen: Date.now(),
      currentPage: window.location.href,
      isOnline: true,
      cartCount: 0,
      cartItems: []
    };

    var isFirstSeen = false;
    try {
      isFirstSeen = !localStorage.getItem('gts_traffic_logged');
      if (isFirstSeen && trafficData) {
        localStorage.setItem('gts_traffic_logged', '1');
      }
    } catch(e) {}

    withFirebase(function() {
      try {
        if (isFirstSeen && trafficData) {
          Object.keys(trafficData).forEach(function(k) {
            visitorData[k] = trafficData[k];
          });
        }
        db.collection('visitors').doc(sessionId).set(visitorData, { merge: true });
      } catch(e) {}
    });

    // Page history tracking
    withFirebase(function() {
      try { db.collection('visitors').doc(sessionId).set({
        pageHistory: firebase.firestore.FieldValue.arrayUnion({
          page: window.location.href,
          ts: Date.now()
        })
      }, { merge: true }); } catch(e) {}
    });

    // ============ CART EVENT LOGGING στη ΝΕΑ collection ============
    function logCartEvent(eventType, eventData) {
      withFirebase(function() {
        try {
          var event = Object.assign({
            type: eventType,
            ts: Date.now(),
            page: window.location.href
          }, eventData);
          db.collection('cart_events').doc(sessionId).set({
            sessionId: sessionId,
            isB2B: IS_B2B,
            updatedAt: Date.now(),
            events: firebase.firestore.FieldValue.arrayUnion(event)
          }, { merge: true });
        } catch(e) {}
      });
    }

    // Cart tracking — every 10 seconds
    if (!SKIP_TRACKING) {
      setInterval(function() {
        fetch('/cart.js').then(function(r){return r.json();}).then(function(cart) {
          currentCart = cart; // αποθήκευση για cart context awareness

          withFirebase(function() {
            try { db.collection('visitors').doc(sessionId).set({
              cartCount: cart.item_count,
              cartItems: cart.items.map(function(i){ return { title: i.title, quantity: i.quantity, price: (i.price/100).toFixed(2) }; }),
              lastSeen: Date.now()
            }, { merge: true }); } catch(e) {}
          });

          var currentSnapshot = {};
          cart.items.forEach(function(item) {
            currentSnapshot[item.variant_id] = {
              title: item.title,
              variant_title: item.variant_title || '',
              quantity: item.quantity,
              price: (item.price / 100).toFixed(2),
              sku: item.sku || ''
            };
          });

          if (lastCartSnapshot !== null) {
            Object.keys(currentSnapshot).forEach(function(vid) {
              var curr = currentSnapshot[vid];
              var prev = lastCartSnapshot[vid];
              if (!prev) {
                logCartEvent('cart_add', {
                  product_title: curr.title,
                  variant: curr.variant_title,
                  quantity: curr.quantity,
                  price: curr.price,
                  sku: curr.sku
                });
              } else if (prev.quantity !== curr.quantity) {
                logCartEvent('cart_update', {
                  product_title: curr.title,
                  variant: curr.variant_title,
                  old_quantity: prev.quantity,
                  new_quantity: curr.quantity,
                  price: curr.price
                });
              }
            });
            Object.keys(lastCartSnapshot).forEach(function(vid) {
              if (!currentSnapshot[vid]) {
                var prev = lastCartSnapshot[vid];
                logCartEvent('cart_remove', {
                  product_title: prev.title,
                  variant: prev.variant_title,
                  quantity: prev.quantity
                });
              }
            });
          }
          lastCartSnapshot = currentSnapshot;
        }).catch(function(){});
      }, 10000);

      // Initial cart snapshot (no events fired)
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart) {
        currentCart = cart;
        var snapshot = {};
        cart.items.forEach(function(item) {
          snapshot[item.variant_id] = {
            title: item.title,
            variant_title: item.variant_title || '',
            quantity: item.quantity,
            price: (item.price / 100).toFixed(2),
            sku: item.sku || ''
          };
        });
        lastCartSnapshot = snapshot;
      }).catch(function(){});
    }

    // Checkout tracking
    document.addEventListener('click', function(e) {
      var el = e.target;
      while(el && el.tagName) {
        var href = el.href || '';
        var txt = (el.textContent || '').toLowerCase().trim().substring(0,20);
        if (href.indexOf('checkout') !== -1 || txt.indexOf('checkout') !== -1) {
          withFirebase(function() {
            try { db.collection('visitors').doc(sessionId).set({
              currentPage: '\u2192 CHECKOUT',
              lastSeen: Date.now()
            }, { merge: true }); } catch(e) {}
          });
          fetch('/cart.js').then(function(r){return r.json();}).then(function(cart) {
            logCartEvent('checkout_clicked', {
              total: (cart.total_price / 100).toFixed(2),
              currency: cart.currency || 'EUR',
              items_count: cart.item_count,
              items: cart.items.map(function(i) {
                return {
                  title: i.title,
                  variant: i.variant_title || '',
                  quantity: i.quantity,
                  price: (i.price / 100).toFixed(2)
                };
              })
            });
          }).catch(function(){
            logCartEvent('checkout_clicked', {});
          });
          break;
        }
        el = el.parentElement;
      }
    });

    function saveSession() {
      try { sessionStorage.setItem('gts_chat', JSON.stringify({ hist: hist, email: userEmail, name: userName, greeted: greeted, sessionId: sessionId, lang: lang, langDetected: langDetected, tokIn: tokIn, tokOut: tokOut, tokCW: tokCW, tokCR: tokCR, emailAsked: emailAsked })); } catch(e) {}
    }

    function fbSet(data) {
      withFirebase(function() {
        try { db.collection('conversations').doc(sessionId).set(data, { merge: true }); } catch(e) {}
      });
    }

    function saveToFirebase(extra) {
      withFirebase(function() {
        db.collection('conversations').doc(sessionId).get().then(function(snap) {
          var humanMsgs = [];
          if (snap.exists && snap.data().messages) {
            humanMsgs = snap.data().messages.filter(function(m) {
              return m.role === 'human' || m.role === 'system';
            });
          }
          var botMsgs = hist.map(function(m) {
            return { role: m.r === 'user' ? 'user' : 'assistant', content: m.t, ts: m.ts || Date.now() };
          });
          var allMsgs = botMsgs.concat(humanMsgs).sort(function(a, b) { return (a.ts || 0) - (b.ts || 0); });
          var data = Object.assign({
            sessionId: sessionId,
            email: userEmail || 'anonymous',
            name: userName || '',
            language: lang,
            startedAt: Date.now(),
            updatedAt: Date.now(),
            isB2B: IS_B2B,
            tokensIn: tokIn, tokensOut: tokOut, cacheWrite: tokCW, cacheRead: tokCR,
            messages: allMsgs
          }, extra || {});
          try { db.collection('conversations').doc(sessionId).set(data, { merge: true }); } catch(e) {}
        }).catch(function() {
          var data = Object.assign({
            sessionId: sessionId,
            email: userEmail || 'anonymous',
            name: userName || '',
            language: lang,
            startedAt: Date.now(),
            updatedAt: Date.now(),
            isB2B: IS_B2B,
            tokensIn: tokIn, tokensOut: tokOut, cacheWrite: tokCW, cacheRead: tokCR,
            messages: hist.map(function(m) { return { role: m.r === 'user' ? 'user' : 'assistant', content: m.t, ts: Date.now() }; })
          }, extra || {});
          try { db.collection('conversations').doc(sessionId).set(data, { merge: true }); } catch(e) {}
        });
      });
    }

    function updateTyping(text) {
      fbSet({ liveTyping: text, updatedAt: Date.now() });
    }

    function listenForHumanMessages() {
      withFirebase(function() {
        try {
          db.collection('conversations').doc(sessionId).onSnapshot(function(snap) {
            if (!snap.exists) return;
            var data = snap.data();

            if (data.humanJoined && !humanMode) {
              humanMode = true;
              addSystemMsg('Kostas joined the conversation');
              snd.disabled = false;
              loading = false;
            }

            if (!data.humanJoined && humanMode) {
              humanMode = false;
              addSystemMsg('Mr.Leaf is back!');
              snd.disabled = false;
              loading = false;
            }

            if (data.lastHumanMessage && data.lastHumanMessage.ts) {
              var stored = sessionStorage.getItem('gts_last_human_ts');
              if (stored !== String(data.lastHumanMessage.ts)) {
                sessionStorage.setItem('gts_last_human_ts', String(data.lastHumanMessage.ts));
                addHumanMsg(data.lastHumanMessage.text);
              }
            }
          });
        } catch(e) {}
      });
    }

    function detectAndSaveLang(text, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', GURL, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.timeout = 5000;
      xhr.onreadystatechange = function() {
        if (xhr.readyState !== 4) return;
        try {
          var d = JSON.parse(xhr.responseText);
          if (d.usage) {
            tokIn += d.usage.input_tokens || 0;
            tokOut += d.usage.output_tokens || 0;
            tokCW += d.usage.cache_creation_input_tokens || 0;
            tokCR += d.usage.cache_read_input_tokens || 0;
          }
          var detected = (d.content && d.content[0] ? d.content[0].text : 'en').trim().toLowerCase().replace(/[^a-z]/g,'').substring(0,2);
          var valid = ['el','en','de','fr','it','es','nl','pl','pt'];
          if (valid.indexOf(detected) === -1) detected = 'en';
          lang = detected;
          langDetected = true;
          saveSession();
          fbSet({ language: lang, updatedAt: Date.now() });
        } catch(e) {}
        cb();
      };
      xhr.ontimeout = function() { cb(); };
      xhr.onerror = function() { cb(); };
      xhr.send(JSON.stringify({
        system: 'Detect the language of this text. Reply with ONLY the 2-letter ISO 639-1 code. Examples: "el" for Greek, "fr" for French, "de" for German, "en" for English. Nothing else, just the code.',
        messages: [{ role: 'user', content: text }]
      }));
    }

    function stripHtml(html) { return html ? html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim() : ''; }
    function truncate(str, n) { return str && str.length > n ? str.substring(0, n) + '...' : str; }

    // ============ CART CONTEXT — δημιουργείται κάθε φορά πριν στείλουμε prompt ============
    function buildCartContext() {
      if (!currentCart || !currentCart.items || currentCart.items.length === 0) {
        return '\nCART STATUS: empty.';
      }
      var lines = currentCart.items.map(function(i) {
        return '- ' + i.title + (i.variant_title ? ' (' + i.variant_title + ')' : '') +
          ' x' + i.quantity + ' @ \u20ac' + (i.price/100).toFixed(2);
      }).join('\n');
      var total = (currentCart.total_price/100).toFixed(2);
      var count = currentCart.item_count;

      // Promotions context (B2C only — Buy 5 Get 1 Free, Free shipping 3+)
      var promoNote = '';
      if (!IS_B2B) {
        var toFreeShip = Math.max(0, 3 - count);
        var toFreeItem = Math.max(0, 5 - count);
        if (toFreeShip > 0) {
          promoNote += '\n- Customer needs ' + toFreeShip + ' more item(s) for FREE SHIPPING (3+ items).';
        } else {
          promoNote += '\n- Customer ALREADY qualifies for FREE SHIPPING.';
        }
        if (toFreeItem > 0 && count >= 3) {
          promoNote += '\n- Customer needs ' + toFreeItem + ' more item(s) to get 1 FREE (Buy 5 Get 1 Free).';
        } else if (count >= 5) {
          promoNote += '\n- Customer ALREADY qualifies for Buy 5 Get 1 Free.';
        }
      }

      return '\nCART STATUS: ' + count + ' item(s), total \u20ac' + total + '\n' + lines + promoNote +
        '\nUse this cart info naturally if relevant to customer\'s question. Mention promotions only when contextually useful, not in every reply.';
    }

    function buildSys(prods, colls, pages) {
      var filteredProds = IS_B2B ? prods : (prods || []).filter(function(p) {
        var minPrice = Math.min.apply(null, p.variants.map(function(v) { return parseFloat(v.price) || 0; }));
        return minPrice >= 15;
      });

      if (!IS_B2B) {
        filteredProds = (filteredProds || []).filter(function(p) {
          var vendor = (p.vendor || '').toLowerCase();
          return vendor !== 'yuki' && vendor !== 'yuki kid';
        });
      }

      var plines = (filteredProds || []).slice(0, 60).map(function(p) {
        var prices = p.variants.map(function(v) { return parseFloat(v.price) || 0; });
        var lo = Math.min.apply(null, prices), hi = Math.max.apply(null, prices);
        var pr = lo == hi ? '\u20ac' + lo.toFixed(2) : '\u20ac' + lo.toFixed(2) + '-\u20ac' + hi.toFixed(2);
        var colorMap = {};
        p.variants.forEach(function(v) {
          var size = v.option1 || '', color = v.option2 || 'default';
          if (!colorMap[color]) colorMap[color] = { avail: [], unavail: [] };
          if (v.available) { colorMap[color].avail.push(size); } else { colorMap[color].unavail.push(size); }
        });
        var variantStr = Object.keys(colorMap).map(function(color) {
          var info = colorMap[color], parts = [];
          if (info.avail.length) parts.push('available: ' + info.avail.join(','));
          if (info.unavail.length) parts.push('sold out: ' + info.unavail.join(','));
          return color + '(' + parts.join('|') + ')';
        }).join('; ');
        var desc = truncate(stripHtml(p.body_html), 70);
        var url = 'https://green-tshirts.com/products/' + p.handle;
        return p.title + ' | ' + p.vendor + ' | ' + pr + ' | ' + variantStr + ' | URL:' + url + (desc ? ' | ' + desc : '');
      }).join('\n');

      // COST FIX: το mr-leaf-kb (λειτουργικό KB) μένει πλήρες. Το our-story
      // (αφήγηση μάρκας) και οι υπόλοιπες σελίδες κόβονται — έστελναν χιλιάδες
      // περιττούς χαρακτήρες σε ΚΑΘΕ μήνυμα.
      var pageContent = (pages || []).map(function(p) {
        var limit = p.handle === 'mr-leaf-kb' ? 15000
                  : p.handle === 'our-story' ? 2500
                  : 1500;
        return '--- ' + p.title + ' ---\n' + truncate(stripHtml(p.body_html), limit);
      }).join('\n\n');

      var currentPage = '';
      if (PT) { currentPage = '\nCustomer is viewing: "' + PT + '" (' + PP + ', ' + (PA === 'true' ? 'in stock' : 'out of stock') + '). Description: ' + truncate(PD, 200); }
      else if (CT) { currentPage = '\nCustomer is browsing collection: "' + CT + '" (' + CC + ' products)'; }

      var emailInfo = userEmail && userEmail !== 'skipped' ? '\nCustomer email: ' + userEmail : '';
      var nameInfo = userName ? '\nCustomer first name: ' + userName + '. Address them by their first name naturally.' : '';

      var retailersInfo = retailersList
        ? '\n\nRETAILERS (Store Name | Address | City | Region | Country):\n' + retailersList
          + '\nFor store questions: search by REGION. Show ALL stores in that region. Then add "For full details: https://green-tshirts.com/pages/find-a-store".'
        : '';

      var contextNote = IS_B2B
        ? 'CONTEXT: B2B wholesale customer.'
        : 'CONTEXT: Retail (B2C) customer. NEVER mention wholesale prices or any price under \u20ac15.';

      var brandsNote = IS_B2B
        ? 'BRANDS: Replica (organic cotton, bold designs). Yuki (minimalist, premium). Yuki Kid (children\'s).\n\n'
        : 'BRANDS: Replica (organic cotton, bold designs, made in Greece since 2004).\n\n';

      var yukiRule = !IS_B2B
        ? '- NEVER mention Yuki or Yuki Kid \u2014 they are not available in this store.\n'
        : '';

      return 'You are Mr.Leaf, a friendly shopping assistant for Green T-Shirts (green-tshirts.com).\n\n'
        + 'CRITICAL IDENTITY RULE: You are ALWAYS Mr.Leaf. NEVER reveal you are Claude, an AI by Anthropic, or any other model. NEVER mention your underlying technology. If you receive a confusing or empty message, respond simply in the customer\'s language: "Πώς μπορώ να σε βοηθήσω;" / "How can I help you?" — never explain what you are.\n\n'
        + 'IMPORTANT: "Green T-Shirts" is the STORE NAME, not a product color. Products come in many colors.\n\n'
        + 'DESIGNER: All designs by Kostas Vasiliagos, founder & sole designer since 2004. "Replica" inspired by Isaac Asimov. Story: https://green-tshirts.com/pages/our-story\n\n'
        + contextNote + '\n\n'
        + 'B2B: https://green-tshirts.com/pages/b2b-form-request\n\n'
        + brandsNote
        + 'PROMOTIONS: Free shipping 3+ items. Buy 5 get 1 free.\n\n'
        + 'SHIPPING: Dispatched 24h. Greece DHL 1-3d. Europe DHL 4-5d. Rest Hellenic Post 8-12d. NO USA shipping.\n\n'
        + 'PRODUCTS:\n' + plines + '\n\n'
        + 'STORE INFO:\n' + pageContent
        + retailersInfo + '\n'
        + currentPage + emailInfo + nameInfo + '\n\n'
        + 'RULES:\n'
        + yukiRule
        + '- Reply in customer language. Casual, warm, friendly.\n'
        + '- Greek: "παραγγελια" not "παραγγελμα", "η ομαδα μας" not "ταμειο".\n'
        + '- No markdown. Max 2-3 sentences.\n'
        + '- Never translate product names.\n'
        + '- NEVER mention prices unless asked ("τιμη","ποσο","price","cost","how much").\n'
        + '- Product URLs: use EXACTLY the URL from data, same tab.\n'
        + '- BESTSELLERS: You do NOT have sales data. NEVER claim a product is popular, bestseller, or "loved by customers" based on stock availability or color options. Stock levels do not indicate popularity. If asked for bestsellers, honestly say you do not have sales data, then ask what kind of design or theme they are interested in (sport, nature, music, etc.) and suggest based on their preference.\n'
        + '- CART AWARENESS: You can see the customer\'s current cart in the CART STATUS section (refreshed each message). Use it naturally: if they ask "what\'s in my cart?", list it. If relevant, mention promotion progress (e.g. "you need 1 more item for free shipping"). Do NOT mention the cart in every reply \u2014 only when it adds value.\n'
        + '- HANDOFF: If customer asks for human/agent/person, ask them in their language: "Would you like me to direct you to our contact form? You can leave a message there and we\'ll get back to you right away!" If they confirm, reply ONLY with: "Perfect! I will now direct you to our contact form." \u2014 nothing else, no link.\n'
        + '- Knowledge base in STORE INFO: always prioritize.\n'
        + '- Tracking: login at green-tshirts.com.\n'
        + '- Unknown: info@green-tshirts.com';
    }

    function loadStore(cb) {
      if (ready) { cb(); return; }
      Promise.all([
        fetch('/products.json?limit=250').then(function(r) { return r.json(); }),
        fetch('/collections.json?limit=50').then(function(r) { return r.json(); }),
        fetch('/pages.json?limit=50').then(function(r) { return r.json(); })
      ]).then(function(res) {
        sys = buildSys(res[0].products, res[1].collections, res[2].pages);
        ready = true; cb();
      }).catch(function() {
        sys = 'You are Mr.Leaf, shopping assistant for Green T-Shirts. NO USA shipping. Reply in customer language. Short. No markdown.';
        ready = true; cb();
      });
    }

    function callAPI(text, cb) {
      // Το user message είναι ΗΔΗ στο hist (μπήκε από το send()).
      // Δεν το ξανα-προσθέτουμε εδώ — αλλιώς στέλνουμε duplicate user messages
      // και το Anthropic API επιστρέφει error.
      var messages = [];
      hist.forEach(function(m) { messages.push({ role: m.r, content: m.t }); });

      // Ασφαλιστική δικλείδα: το τελευταίο μήνυμα ΠΡΕΠΕΙ να είναι από user.
      var lastMsg = messages[messages.length - 1];
      if (!lastMsg || lastMsg.role !== 'user') {
        cb('No user message to respond to', null);
        return;
      }

      function actuallySend() {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', GURL, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onreadystatechange = function() {
          if (xhr.readyState !== 4) return;
          try {
            var d = JSON.parse(xhr.responseText);
            if (d.error) { cb(d.error.message || JSON.stringify(d.error), null); return; }
            // Σωρεύουμε τα πραγματικά tokens (input/output/cache) για το κόστος.
            if (d.usage) {
              tokIn += d.usage.input_tokens || 0;
              tokOut += d.usage.output_tokens || 0;
              tokCW += d.usage.cache_creation_input_tokens || 0;
              tokCR += d.usage.cache_read_input_tokens || 0;
            }
            cb(null, d.content[0].text);
          } catch(e) { cb('Error: ' + xhr.responseText, null); }
        };
        // COST FIX: στέλνουμε το ΣΤΑΘΕΡΟ system (κατάλογος+KB) ξεχωριστά από το
        // ΔΥΝΑΜΙΚΟ cart context, ώστε ο proxy να κάνει prompt-caching μόνο στο
        // σταθερό κομμάτι. Έτσι τα επόμενα μηνύματα κοστίζουν ~90% λιγότερο.
        xhr.send(JSON.stringify({ system: (sys || ''), cartContext: buildCartContext(), messages: messages }));
      }

      if (!sys) {
        loadStore(function() { actuallySend(); });
      } else {
        actuallySend();
      }
    }

    var btn      = document.getElementById('gts-btn');
    var btnImg   = document.getElementById('gts-btn-img');
    var btnX     = document.getElementById('gts-btn-x');
    var win      = document.getElementById('gts-win');
    var xcl      = document.getElementById('gts-x');
    var emailScr = document.getElementById('gts-email-screen');
    var chatArea = document.getElementById('gts-chat-area');
    var emailInp = document.getElementById('gts-email-input');
    var emailBtn = document.getElementById('gts-email-btn');
    var box      = document.getElementById('gts-msgs');
    var inp      = document.getElementById('gts-inp');
    var snd      = document.getElementById('gts-snd');

    function makeAvatar() {
      var av = document.createElement('div');
      av.className = 'ga';
      av.innerHTML = '<img src="' + AVATAR + '" alt="Mr.Leaf"/>';
      return av;
    }

    function addMsg(side, text) {
      var row = document.createElement('div');
      row.className = 'gr ' + side;
      if (side == 'b') row.appendChild(makeAvatar());
      var bbl = document.createElement('div');
      bbl.className = 'gmsg ' + side;
      var escaped = text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      var linked = escaped.replace(/(https?:\/\/[^\s]+)/g, function(url) {
        var clean = url.replace(/[.,;!?]$/, '');
        return '<a href="' + clean + '">' + clean + '</a>';
      });
      bbl.innerHTML = linked;
      row.appendChild(bbl);
      box.appendChild(row);
      box.scrollTop = box.scrollHeight;
    }

    function addSystemMsg(text) {
      var row = document.createElement('div');
      row.style.cssText = 'text-align:center;padding:6px;font-size:12px;color:#888;font-style:italic';
      row.textContent = '\u2014 ' + text + ' \u2014';
      box.appendChild(row);
      box.scrollTop = box.scrollHeight;
    }

    function addHumanMsg(text) {
      var row = document.createElement('div');
      row.className = 'gr b';
      var av = document.createElement('div');
      av.className = 'ga';
      av.style.cssText = 'background:#e07b39;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:700;font-size:11px;border-color:#e07b39';
      av.textContent = 'K';
      row.appendChild(av);
      var bbl = document.createElement('div');
      bbl.className = 'gmsg b';
      bbl.style.borderColor = '#f0c8a0';
      bbl.textContent = text;
      row.appendChild(bbl);
      box.appendChild(row);
      box.scrollTop = box.scrollHeight;
    }

    // ========================================================================
    // TEST — Προαιρετικό email prompt ΜΕΣΑ στη συνομιλία, μετά τη 2η ερώτηση
    //
    // Αντί για υποχρεωτική οθόνη email πριν το chat (παλιά συμπεριφορά, αφαιρέθηκε),
    // εμφανίζουμε ένα μη-υποχρεωτικό bubble ΜΕΣΑ στη ροή της συνομιλίας, αφού ο
    // πελάτης έχει ήδη κάνει 2 ερωτήσεις. Skippable, δεν μπλοκάρει τίποτα.
    // Το outcome (provided/skipped) γράφεται στο Firestore ώστε να φαίνεται στο
    // dashboard/analyst πόσοι δίνουν email όταν δεν είναι υποχρεωτικό.
    // ========================================================================
    function showEmailPromptBubble() {
      var t = emailAskMsgs[lang] || emailAskMsgs['en'];
      var b = emailAskBtns[lang] || emailAskBtns['en'];

      var row = document.createElement('div');
      row.className = 'gr b';
      row.appendChild(makeAvatar());

      var bbl = document.createElement('div');
      bbl.className = 'gmsg b';

      var label = document.createElement('div');
      label.style.cssText = 'margin-bottom:8px';
      label.textContent = t;
      bbl.appendChild(label);

      var eInp = document.createElement('input');
      eInp.type = 'email';
      eInp.placeholder = 'email@example.com';
      eInp.style.cssText = 'width:100%;padding:8px 10px;margin-bottom:8px;border:1.5px solid #c8e6c4;border-radius:8px;font-size:13px;outline:none;box-sizing:border-box';
      bbl.appendChild(eInp);

      var btnRow = document.createElement('div');
      btnRow.style.cssText = 'display:flex;gap:8px';
      var sendBtn = document.createElement('button');
      sendBtn.type = 'button';
      sendBtn.textContent = b.send;
      sendBtn.style.cssText = 'padding:7px 14px;border:none;border-radius:8px;background:#2d5a28;color:#fff;font-size:12.5px;font-weight:600;cursor:pointer';
      var skipBtn = document.createElement('button');
      skipBtn.type = 'button';
      skipBtn.textContent = b.skip;
      skipBtn.style.cssText = 'padding:7px 14px;border:1.5px solid #ddd;border-radius:8px;background:#fff;color:#666;font-size:12.5px;cursor:pointer';
      btnRow.appendChild(sendBtn);
      btnRow.appendChild(skipBtn);
      bbl.appendChild(btnRow);

      row.appendChild(bbl);
      box.appendChild(row);
      box.scrollTop = box.scrollHeight;

      function resolvePrompt(outcome) {
        sendBtn.disabled = true; skipBtn.disabled = true; eInp.disabled = true;
        sendBtn.style.opacity = '0.5'; skipBtn.style.opacity = '0.5';
        var note = document.createElement('div');
        note.style.cssText = 'margin-top:8px;font-size:12px;color:#4a7c45;font-style:italic';
        note.textContent = outcome === 'provided' ? b.thanks : b.ok;
        bbl.appendChild(note);
        fbSet({ emailPromptOutcome: outcome, emailPromptAt: Date.now() });
      }

      sendBtn.addEventListener('click', function() {
        var email = eInp.value.trim();
        if (!email || email.indexOf('@') === -1) { eInp.style.borderColor = '#e07b39'; eInp.focus(); return; }
        userEmail = email;
        saveSession();
        fbSet({ email: userEmail, updatedAt: Date.now() });
        if (!SKIP_TRACKING) {
          fetch(GURL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ type: 'email_capture', email: userEmail, name: userName })
          }).catch(function() {});
        }
        resolvePrompt('provided');
      });

      skipBtn.addEventListener('click', function() { resolvePrompt('skipped'); });
      eInp.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); sendBtn.click(); } });
    }

    // Καλείται μετά από κάθε bot reply. Δείχνει το prompt ΜΙΑ φορά ανά συνομιλία,
    // αφού ο πελάτης έχει στείλει ήδη 2 μηνύματα, εφόσον δεν έχουμε ήδη email.
    function maybeShowEmailPrompt() {
      if (userEmail || emailAsked || SKIP_TRACKING) return;
      var userMsgCount = hist.filter(function(m) { return m.r === 'user'; }).length;
      if (userMsgCount >= 2) {
        emailAsked = true;
        saveSession();
        fbSet({ emailPromptShown: true, emailPromptShownAt: Date.now() });
        showEmailPromptBubble();
      }
    }

    function showTyping() {
      if (document.getElementById('gts-ty')) return;
      var row = document.createElement('div');
      row.className = 'gr b'; row.id = 'gts-ty';
      row.appendChild(makeAvatar());
      var t = document.createElement('div');
      t.className = 'gty'; t.innerHTML = '<span></span><span></span><span></span>';
      row.appendChild(t); box.appendChild(row);
      box.scrollTop = box.scrollHeight;
    }

    function hideTyping() { var t = document.getElementById('gts-ty'); if (t) t.parentNode.removeChild(t); }

    function renderAllMsgsFromFirebase() {
      withFirebase(function() {
        db.collection('conversations').doc(sessionId).get().then(function(snap) {
          if (!snap.exists) return;
          var msgs = snap.data().messages || [];
          var hasHuman = msgs.some(function(m) { return m.role === 'human' || m.role === 'system'; });
          if (!hasHuman) return;
          box.innerHTML = '';
          msgs.forEach(function(m) {
            if (m.role === 'user') { addMsg('u', m.content); }
            else if (m.role === 'assistant') { addMsg('b', m.content); }
            else if (m.role === 'human') { addHumanMsg(m.content); }
            else if (m.role === 'system') { addSystemMsg(m.content); }
          });
        }).catch(function() {});
      });
    }

    // ========================================================================
    // BONUS BUG FIX — Race condition guard για το humanJoined
    //
    // Πρόβλημα: μεταξύ του ελέγχου humanJoined (πριν την κλήση API) και της
    // απάντησης του Claude (μετά), μπορεί ο Kostas να έχει κάνει join. Αν δεν
    // ξανα-ελέγξουμε, η απάντηση του bot σώζεται στο Firebase και εμφανίζεται
    // στον πελάτη ως «φάντασμα μήνυμα», παρόλο που πλέον είναι σε human mode.
    //
    // Λύση: μετά την επιστροφή του API, ξανα-διαβάζουμε το humanJoined και
    // ΑΠΟΡΡΙΠΤΟΥΜΕ ΣΙΩΠΗΛΑ την απάντηση του bot αν στο μεταξύ έγινε join.
    // ========================================================================
    function persistBotReply(reply) {
      // Helper: σώζει την απάντηση τοπικά + Firebase + αλλάζει σελίδα αν χρειάζεται
      hist.push({ r: 'assistant', t: reply, ts: Date.now() });
      addMsg('b', reply);
      saveSession();
      saveToFirebase({});
      if (reply.indexOf('I will now direct you') !== -1) {
        setTimeout(function() {
          window.location.href = 'https://green-tshirts.com/pages/contact';
        }, 3500);
      }
      maybeShowEmailPrompt();
    }

    function doSend(text) {
      if (SKIP_TRACKING) {
        // Admin/bot: απλά κλήση API χωρίς Firestore writes
        showTyping();
        loadStore(function() {
          callAPI(text, function(err, reply) {
            hideTyping(); loading = false; snd.disabled = false;
            if (err || !reply) { addMsg('b', err || 'Something went wrong. Please try again.'); }
            else {
              hist.push({ r: 'assistant', t: reply, ts: Date.now() });
              addMsg('b', reply);
              saveSession();
            }
          });
        });
        return;
      }

      withFirebase(function() {
        db.collection('conversations').doc(sessionId).get().then(function(snap) {
          var isHumanJoined = snap.exists && snap.data().humanJoined === true;

          if (isHumanJoined) {
            db.collection('conversations').doc(sessionId).set({
              updatedAt: Date.now(),
              messages: firebase.firestore.FieldValue.arrayUnion({
                role: 'user', content: text, ts: Date.now()
              })
            }, { merge: true });
            loading = false;
            snd.disabled = false;
            return;
          }

          showTyping();
          loadStore(function() {
            callAPI(text, function(err, reply) {
              hideTyping(); loading = false; snd.disabled = false;
              if (err || !reply) { addMsg('b', err || 'Something went wrong. Please try again.'); return; }

              // Race condition guard: re-check humanJoined ΜΕΤΑ την κλήση API.
              // Αν στο μεταξύ έκανε join ο Kostas, η απάντηση του bot ρίχνεται.
              db.collection('conversations').doc(sessionId).get().then(function(s2) {
                if (s2.exists && s2.data().humanJoined === true) {
                  console.log('[Mr.Leaf] Kostas joined during API call - bot reply dropped');
                  // Καταγράφουμε το user message μόνο (όχι το assistant reply)
                  db.collection('conversations').doc(sessionId).set({
                    updatedAt: Date.now(),
                    messages: firebase.firestore.FieldValue.arrayUnion({
                      role: 'user', content: text, ts: Date.now()
                    })
                  }, { merge: true });
                  return;
                }
                persistBotReply(reply);
              }).catch(function() {
                // Σε περίπτωση error στον έλεγχο, σώσε κανονικά (συμβατότητα)
                persistBotReply(reply);
              });
            });
          });
        }).catch(function() {
          showTyping();
          loadStore(function() {
            callAPI(text, function(err, reply) {
              hideTyping(); loading = false; snd.disabled = false;
              if (err || !reply) { addMsg('b', err || 'Something went wrong. Please try again.'); }
              else {
                persistBotReply(reply);
              }
            });
          });
        });
      });
    }

    function send() {
      var text = inp.value.trim();
      if (!text || loading) return;
      inp.value = '';
      updateTyping('');
      snd.disabled = true;
      loading = true;
      hist.push({ r: 'user', t: text, ts: Date.now() });
      addMsg('u', text);
      // COST FIX: ανίχνευση γλώσσας ΜΟΝΟ την πρώτη φορά ανά συνομιλία.
      // Πριν: έτρεχε ξεχωριστή κλήση API σε ΚΑΘΕ μήνυμα (διπλάσιες κλήσεις/tokens).
      if (!langDetected) {
        detectAndSaveLang(text, function() { doSend(text); });
      } else {
        doSend(text);
      }
    }

    function startChat() {
      emailScr.style.display = 'none';
      chatArea.style.display = 'flex';
      chatArea.style.flexDirection = 'column';
      if (hist.length > 0) {
        hist.forEach(function(m) { addMsg(m.r === 'user' ? 'u' : 'b', m.t); });
        setTimeout(renderAllMsgsFromFirebase, 800);
      } else if (!greeted) {
        greeted = true;
        userName = sessionStorage.getItem('gts_chat') ? JSON.parse(sessionStorage.getItem('gts_chat')).name || '' : '';
        var greeting = userName ? 'Hi ' + userName + '!' : 'Hi!';
        var msg = PT ? greeting + ' I see you are viewing "' + PT + '". How can I help?'
          : CT ? greeting + ' Browsing ' + CT + ' (' + CC + ' products). What are you looking for?'
          : userName ? greeting + ' Welcome to Green T-Shirts. How can I help you?'
          : (greetings[lang] || greetings['en']);
        addMsg('b', msg);
        hist.push({ r: 'assistant', t: msg, ts: Date.now() });
        saveSession();
        saveToFirebase({ humanJoined: false });
      }
      inp.focus();
      loadStore(function() {});
      listenForHumanMessages();
    }

    // TEST: καταγραφή "άνοιξε το chat" ξεχωριστά από "έστειλε μήνυμα" (visitors
    // collection), ώστε να φαίνεται στο dashboard πόσοι ανοίγουν το widget αλλά
    // δεν ξεκινούν καν συζήτηση — funnel: opens -> πρώτο μήνυμα -> 2η ερώτηση/email.
    function logChatOpened() {
      if (chatOpenedLogged) return;
      chatOpenedLogged = true;
      withFirebase(function() {
        try {
          db.collection('visitors').doc(sessionId).set({
            chatOpened: true,
            chatOpenedAt: Date.now()
          }, { merge: true });
        } catch(e) {}
      });
    }

    function openChat() {
      isOpen = true;
      win.classList.add('open');
      btnImg.style.display = 'none';
      btnX.style.display = 'flex';
      logChatOpened();
      // TEST: αφαιρέθηκε το email/name gate — ο επισκέπτης μπαίνει κατευθείαν
      // στο chat χωρίς να χρειάζεται πρώτα να συμπληρώσει στοιχεία.
      startChat();
    }

    function closeChat() {
      isOpen = false;
      win.classList.remove('open');
      btnImg.style.display = 'block';
      btnX.style.display = 'none';
    }

    inp.addEventListener('input', function() {
      snd.disabled = inp.value.trim().length == 0 || loading;
      clearTimeout(typingTimer);
      typingTimer = setTimeout(function() { updateTyping(inp.value); }, 300);
    });

    emailBtn.addEventListener('click', function() {
      var email = emailInp.value.trim();
      var name = document.getElementById('gts-name-input').value.trim();
      if (!name) {
        document.getElementById('gts-name-input').style.borderColor = '#e07b39';
        document.getElementById('gts-name-input').focus();
        return;
      }
      if (!email || !email.includes('@')) {
        emailInp.style.borderColor = '#e07b39';
        emailInp.focus();
        return;
      }
      userEmail = email;
      userName = name;
      saveSession();
      fbSet({ email: userEmail, name: userName, updatedAt: Date.now() });
      if (!SKIP_TRACKING) {
        fetch(GURL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ type: 'email_capture', email: userEmail, name: userName })
        }).catch(function() {});
      }
      startChat();
    });

    emailInp.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); emailBtn.click(); }
    });

    document.getElementById('gts-name-input').addEventListener('keydown', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); emailBtn.click(); }
    });

    btn.addEventListener('click', function() { isOpen ? closeChat() : openChat(); });
    xcl.addEventListener('click', closeChat);
    inp.addEventListener('keydown', function(e) { if (e.key == 'Enter') { e.preventDefault(); send(); } });
    snd.addEventListener('click', send);

    var wb = document.getElementById('gts-welcome-bubble');
    if (wb) {
      wb.addEventListener('click', function(e) {
        if (e.target.id === 'gts-welcome-close') { wb.style.display='none'; return; }
        wb.style.display = 'none';
        openChat();
      });
      setTimeout(function() {
        if (!isOpen && !localStorage.getItem('gts_welcomed')) {
          wb.style.display = 'block';
          localStorage.setItem('gts_welcomed', '1');
        }
      }, 3000);
    }

    btn.addEventListener('click', function() {
      if (wb) wb.style.display = 'none';
    });

    loadFirebase(function() {
      listenForHumanMessages();
    });
    setTimeout(function() { loadStore(function() {}); }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
